import { render, staticRenderFns } from "./DownloadReport.vue?vue&type=template&id=5422b7cc&"
import script from "./DownloadReport.vue?vue&type=script&lang=js&"
export * from "./DownloadReport.vue?vue&type=script&lang=js&"
import style0 from "./DownloadReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports